module.exports = __webpack_public_path__ + "static/1.1.C. OLAR RANDARE 3-063a3dfcb3f0f0747792074abd2724d1.jpg";